import React from 'react';
import { List } from 'react-admin';
// import JourneyGrid from '../../components/JourneyGrid';
import { ShowButton } from 'react-admin';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

export const ContactList = (props) => (
    <List title="Contact Explorer" {...props}>
        <Explorer />
    </List>
);

const defaultCardStyle = {
    width: '100%',
    margin: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top'
};

const Explorer = ({ ids, data, basePath }) => (
    <div style={{ margin: '1em' }}>
        <h2>More on that in our next session</h2>
    </div>
);

Explorer.defaultProps = {
    data: {},
    ids: [],
};



// WEBPACK FOOTER //
// ./src/pages/lists/Contacts.js